import {
  TableCellType,
  TableHeader,
} from "../../../../components/custom-table/table";

export const dxCodeConfigTableHeaders: TableHeader[] = [
  {
    label: "J Code",
    key: "jCode",
    order: 1,
    width: 15,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Drug Type",
    key: "drugName",
    order: 2,
    width: 25,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Dx Codes",
    key: "dxCodes",
    order: 3,
    width: 50,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "",
    key: "actions",
    order: 4,
    width: 10,
    sortable: false,
    type: TableCellType.EDIT_ICON,
  },
];
